import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

const EnergyBills: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('EnergyBills');
    return (
        <div className={styles.EnergyBills}>
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="energy-bills-box page-layout pc">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1751254894463/pc.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1751267303458/1942%20(1).jpg"
                ></EcoImg>
            </div>
            <EcoImg className="pad" pc="https://websiteoss.ecoflow.com/upload/image/1751267303458/1942%20(1).jpg"></EcoImg>
        </div>
    );
};

export default EnergyBills;
